import { availability } from './availability';
import { type } from './type';
import { name } from './name';

export const columns = [name, type, availability];
